import type { OptionalTypedKeys } from '../types/path';

export function getValueOrUndefinedFromNullable<T extends object, K extends keyof T>(value: T | undefined, key: K, defaultValue: T[K]) {
  if (!value) {
    return undefined;
  }

  return value[key] ?? defaultValue;
}

export function getNumberOrUndefinedFromNullable<T extends object, K extends OptionalTypedKeys<T, number | undefined>>(value: T | undefined, key: K) {
  return getValueOrUndefinedFromNullable(value, key, 0 as T[K]);
}

export function getNumericStringOrUndefinedFromNullable<T extends object, K extends OptionalTypedKeys<T, string | undefined>>(
  value: T | undefined,
  key: K,
) {
  return getValueOrUndefinedFromNullable(value, key, '0' as T[K]);
}

export function getBooleanFromUndefinedOrNullable<T extends object, K extends OptionalTypedKeys<T, boolean | undefined>>(
  value: T | undefined,
  key: K,
) {
  return getValueOrUndefinedFromNullable(value, key, false as T[K]);
}

export function getYesNoOrUndefinedFromNullable<T extends object, K extends OptionalTypedKeys<T, boolean | undefined>>(value: T | undefined, key: K) {
  const v = getBooleanFromUndefinedOrNullable(value, key);

  if (v === undefined) {
    return undefined;
  }

  return v ? ('Yes' as const) : ('No' as const);
}
